module.exports = __webpack_public_path__ + "img/liangtang-back-one@2x.7560388d.png";